import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class USStateValidatorService {
    private readonly US_STATES = [
        'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
        'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
        'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
        'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
        'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
        'DC'
    ];

    public usStateValidator<T>(conditional: (group: T) => boolean = () => true): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const groupValue = control.parent?.value;
            if (!groupValue) {
                return null;
            }

            if (!conditional(groupValue)) {
                return null;
            }

            const value = control.value?.toUpperCase();
            if (!value) {
                return null;
            }

            return this.US_STATES.includes(value) ? null : { state: true };
        };
    }
}
